"use client";
import React, { useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import Image from "next/image";
import search from "@/public/images/search.svg";
import bottomArrow from "@/public/images/bottomArrow.svg";
import { Field, Form, Formik } from "formik";
import heart from "@/public/images/heart.svg";
import FaviconIcon from "@/public/Favicon.svg";
import UniversityCard from "@/components/shared/UniversityCard";
import CourseCard from "@/components/shared/CourseCard";

const CoursesClient = () => {
  return (
    <>
      <div className=" bg-primaryColor pt-10 pb-32 flex flex-col gap-5 mb-36">
        <p className=" text-36 text-white font-[500] mb-5 text-center">
          اكتشف أفضل الجامعات والكليات والتخصصات المتاحة.
        </p>
        <p className=" text-18 text-white font-[500] mb-3 text-center">
          ابحث عن أفضل الجامعات و معاهد اللغات في العالم ومراجعتها والتقديم
          إليها
        </p>
        <div className=" relative container  w-full mt-20 bg-white shadow-xl p-5  rounded-[10px] mx-auto -mb-[13rem]">
          <Formik
            initialValues={{ search: "" }}
            onSubmit={(values) => {
              console.log(values, "values");
            }}
          >
            {(props) => (
              <Form className=" relative">
                <Field
                  type="text"
                  name="search"
                  className=" w-full  h-[60px] bg-[#F8F9FA] rounded-[10px] py-3 px-14"
                  placeholder="ابحث عن جامعة"
                />
                <Image
                  src={search}
                  alt="search"
                  className=" absolute top-1/2 -translate-y-1/2 right-5"
                />
              </Form>
            )}
          </Formik>
          <div className=" flex items-center justify-between gap-5 mt-5">
            <div className=" flex items-center gap-5">
              <Popover>
                <PopoverTrigger>
                  <div className=" flex items-center gap-10">
                    <div className=" flex flex-col items-start">
                      <p className=" text-16 text-darkText font-[500]">
                        نوع الكورس
                      </p>
                      <p className=" text-16 text-[#757990]">اختر نوع الكورس</p>
                    </div>
                    <Image src={bottomArrow} alt="bottomArrow" />
                  </div>
                </PopoverTrigger>
                <PopoverContent></PopoverContent>
              </Popover>
              <Popover>
                <PopoverTrigger>
                  <div className=" flex items-center gap-10">
                    <div className=" flex flex-col items-start">
                      <p className=" text-16 text-darkText font-[500]">
                        تخصص الكورس
                      </p>
                      <p className=" text-16 text-[#757990]">اختر تخصص</p>
                    </div>
                    <Image src={bottomArrow} alt="bottomArrow" />
                  </div>
                </PopoverTrigger>
                <PopoverContent></PopoverContent>
              </Popover>
            </div>

            <button
              type="button"
              role="button"
              className=" text-16 text-white bg-primaryColor py-2 px-10 rounded-[10px]"
            >
              فلتره
            </button>
          </div>
        </div>
      </div>
      <div className="  container">
        <div className=" flex items-center justify-between gap-5">
          <p className=" text-20 text-black font-[500]">
            نتائج البحث : <span className=" text-primaryColor"> (468) </span>
          </p>
          <div className=" flex items-center gap-5">
            <p className=" text-14 text-descriptionText flex items-center gap-3 border border-[#F2F2F2] rounded-[10px] py-2 px-7">
              المفضلة <Image src={heart} alt="heart" />
            </p>
            <p className=" text-14 text-descriptionText flex items-center gap-3 border border-[#F2F2F2] rounded-[10px] py-2 px-7">
              نرشحها <Image src={FaviconIcon} alt="favicon" width={20} height={20} />
            </p>
          </div>
        </div>
        <div className=" grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px] my-5">
          {Array.from({ length: 12 }).map((_, index) => (
            <CourseCard key={index} />
          ))}
        </div>
      </div>
    </>
  );
};

export default CoursesClient;
